import { put, call, select } from "redux-saga/effects";

import * as actions from "../actions";

import * as Api from "../../api";
import { getCvUrl } from "../../helpers";

const getFullName = ({
  core: {
    app: { firstName, lastName },
  },
}) => `${firstName} ${lastName}`;

const getEmail = ({ core }) => core.user.email;
const getUserTelephone = ({ core }) => core.app.mobileTelephone;
const getCv = ({ core }) => core.app.cv;

export default function* applyForJobSaga({ jobId }) {
  try {
    const fullName = yield select(getFullName);
    const email = yield select(getEmail);
    const telephone = yield select(getUserTelephone);
    const cv = yield select(getCv);
    const cvUrl = getCvUrl(cv);
    yield put(actions.applySetIsLoading(true));
    const data = {
      jobId,
      cvUrl,
      email,
      telephone,
      fullName,
    };
    const { status, statusText } = yield call(Api.applyForJob, data);
    if (status === 200) {
      yield put(actions.applySuccess());
    } else {
      yield put(actions.applySetError({ error: { status, statusText } }));
    }
  } catch (error) {
    yield put(actions.applySetError({ error }));
  } finally {
    yield put(actions.applySetIsLoading(false));
  }
}
